import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NorthEastIcon(props: IconProps) {
    return <Icon {...props} iconKey={"north_east"}/>
}
